import { render, staticRenderFns } from "./departmentCount.vue?vue&type=template&id=66d4eae3&"
import script from "./departmentCount.vue?vue&type=script&lang=js&"
export * from "./departmentCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports